import type { ITopicVMProps } from '@data/view-models';
import type { IApiRequestProps } from '@core/utils/api';
import type { TQueryKey } from '@react/utils/queryHooks';

import { api } from './api';

export const QK_FETCH_TOPICS: TQueryKey = 'qk_fetchTopics';

function getTopics({ signal }: IApiRequestProps): Promise<ITopicVMProps[]> {
  return api.get<ITopicVMProps[]>({
    signal,
    endpoint: '/topics',
  });
}

export const topicApi = {
  getTopics,
};
